import React, {createRef} from "react";
import Axios from "axios";
import ReactTable from "react-table";

import "react-table/react-table.css";

import HttpRequest from "../services/HttpRequest";
import Box from "../component/Box/Box";
import Notify from "../services/Notify";
import Objects from "../utils/Objects";
import AbortStackRequestService from "../services/AbortStackRequestService";
import RecursiveTimeout from "../utils/recursive-timeout";

class CustomGrid extends React.Component {

  httpRequest = new HttpRequest();

  constructor(props) {
    super(props);
    this.state = {
      metadata: props.metadata,
      customFilter: props.customFilter,
      endpoint: props.endpoint,
      onClickInRow: props.onClickInRow,
      defaultSort: props.defaultSort,
      data: props.data,
      tableStyle: props.tableStyle,
      removeBox: props.removeBox,
      selectRow: props.selectRow,
      pageNumber: 0
    };
    this.tableInstance = createRef();
    this.requestDataOnFilterChange.bind(this)
    window.addEventListener('resize', () => this.setGridHeight());
  }

  static queryArgsBuilder(queryParameters) {
    let queryString = '';
    queryParameters.map(parameter => {
      return queryString += parameter['id'] + '=' + parameter['value'] + '&'
    });
    return queryString;
  }

  componentDidMount() {
    this.setGridHeight();
    this.state.metadata.forceReload = () => {
      this.requestDataOnFilterChange(null);
    }
  }

  componentWillUnmount() {
    const {recursiveTimeout} = this.state
    if (recursiveTimeout) {
      recursiveTimeout.stop()
    }
  }

  componentWillReceiveProps(nextProps) {
    const {customFilter, metadata, endpoint} = this.state;

    if (
      metadata !== nextProps.metadata ||
      customFilter !== nextProps.customFilter ||
      endpoint !== nextProps.endpoint
    ) {

      this.setState({
        endpoint: nextProps.endpoint,
        defaultSort: nextProps.defaultSort,
        customFilter: nextProps.customFilter,
        metadata: nextProps.metadata,
        data: [],
        pageNumber: 0
      }, () => this.requestDataOnFilterChange(null));
    }

    nextProps.metadata.forceReload = () => {
      this.requestDataOnFilterChange(null);
    }

  }

  async getGridData(cancelRequestToken, endpoint) {
    let isRequestCanceled
    try {
      const {metadata} = this.state
      this.setState({loading: true});
      const response = await this.httpRequest.get(endpoint, {cancelToken: cancelRequestToken})
      metadata && metadata.onData && metadata.onData(response);
      this.data = response.content;
      const data = response.content;
      this.setState({data: data, pages: response.totalPages, pageNumber: response.number, loading: false});
    } catch (error) {
      if (Axios.isCancel(error)) {
        return isRequestCanceled = true
      }
      Notify.error('Falha ao buscar dados da entidade: ' + error.message);
    } finally {
      !isRequestCanceled && this.setState({loading: false});
    }
  }

  initAutomaticDataFetch(endpoint) {
    const {recursiveTimeout, metadata} = this.state

    if (recursiveTimeout) {
      recursiveTimeout.stop()
    }

    const observers = {
      onTry: () => AbortStackRequestService.newRequest(this.getGridData.bind(this), [endpoint])
    }

    const newRecursiveTimeout = new RecursiveTimeout(observers, metadata.automaticDataFetchIntervalInMilliseconds);
    newRecursiveTimeout.start()

    this.setState({recursiveTimeout: newRecursiveTimeout})
  }

  requestDataOnFilterChange(tableState) {
    const { isOfflineData, data, metadata } = this.state
    if (isOfflineData) {
      return this.setState({ data })
    }
    const endpoint = this.getUrlWithRequestParams(tableState);

    if (metadata.automaticDataFetch) {
      return this.initAutomaticDataFetch(endpoint)
    }

    AbortStackRequestService.newRequest(this.getGridData.bind(this), [endpoint])
  }

  getUrlWithRequestParams(tableState) {
    const {endpoint, defaultSort = 'createdAt'} = this.state;

    const tableInstance = this.tableInstance.current

    if (Objects.isNullOrUndefined(tableState)) {
      tableState = {filtered: [], sorted: [], page: 0, pageSize: 10}
      tableInstance && tableInstance.updater.enqueueSetState(tableInstance, tableState)
    }

    const pageSize = tableState.pageSize;
    const page = tableState.page;
    const queryArgs = CustomGrid.queryArgsBuilder(tableState.filtered);
    let operatorContact = '?';
    if (endpoint.indexOf('?') > 0) {
      operatorContact = '&';
    }
    const sort = tableState.sorted[0] || {};
    let order= Objects.isNullOrUndefined(sort.desc) || sort.desc ? ',DESC' : ',ASC';

    if(Objects.isNullOrUndefined(sort.desc) && defaultSort){
          if(defaultSort.indexOf(',') >= 0){
            order = '';
          }
    }

    return `${endpoint}${operatorContact}${queryArgs}page=${page}&size=${pageSize}&sort=${sort.id || defaultSort}${order}`;
  }

  setGridHeight() {
    const menuAndBreadcrumbHeight = 270;
    const height = window.innerHeight - menuAndBreadcrumbHeight + 'px';
    this.setState({height});
  }

  render() {
    const {metadata, loading, pages, pageNumber, height, onClickInRow, tableStyle, removeBox, selectRow} = this.state;
    const { columns, getColumns } = metadata;

    const data = !this.props.data ? this.state.data : this.props.data;
    let cols = getColumns ? getColumns(this.props, this.state, this.setState.bind(this)) : columns;
    return (
      <Box hidden={removeBox} info>
        <ReactTable
          ref={this.tableInstance}
          data={data}
          getTrProps={(state, rowInfo) => ({
            onClick: () => {
              selectRow && this.setState({
                selected: JSON.stringify(rowInfo.original)
              })
              onClickInRow && onClickInRow(state, rowInfo)
            },
            style: {
              background: rowInfo && JSON.stringify(rowInfo.original) === this.state.selected && 'RGBA(60,141,188,0.58)'
            }
          })}
          columns={cols}
          defaultPageSize={10}
          //className="colored-table"
          className="-striped -highlight"
          loading={loading}
          manual
          nextText="Próximo"
          previousText="Anterior"
          rowsText="Linhas"
          pageText="Página"
          ofText="de"
          noDataText="Sem dados"
          loadingText="Carregando..."
          onPageChange={page => console.log("PAGE", page)}
          // Controlled props
          page={pageNumber}
          pages={pages}
          height={height}
          style={tableStyle ? tableStyle : null}
          onFetchData={(tableState) => {
            this.requestDataOnFilterChange(tableState)
          }}
        />
      </Box>
    );
  }

}

export default CustomGrid;



// WEBPACK FOOTER //
// ./src/customGrid/CustomGrid.js